import { CopilotCreateData, CopilotUploadPreset } from 'shared/types/copilot'
import { CreationToolUploadTag } from '../../types'

export function mergePresets(presets: CopilotUploadPreset[], newPresets: CopilotUploadPreset[]) {
    const merged = [...presets]

    newPresets.forEach((p) => {
        const foundIndex = presets.findIndex((preset) => preset.id === p.id)

        if (foundIndex < 0) {
            merged.push(p)
        } else {
            merged[foundIndex] = p
        }
    })

    return merged
}

export function createDataFromPreset(name: string, preset: CopilotUploadPreset): CopilotCreateData {
    const {
        upload_channel,
        upload_is_hidden,
        upload_rating,
        upload_source_url = '',
        upload_tags: { tags: presetTags = [] },
        upload_optional_tags: { tags: presetOptionalTags = [] },
        // upload_collections: { collections = [] },
    } = preset

    const featured_tags = presetTags
        .filter((t) => t.is_featured)
        .map((t) => t.name)
        .join(',')

    const tags = presetTags
        .filter((t) => !t.is_featured)
        .map((t) => t.name)
        .join(',')

    const username = upload_channel ? upload_channel.slug : ''
    const optional_tags = presetOptionalTags.map((t) => t.name).join(',')

    return {
        // uncomment this when collections input is updated to support default value
        // collections: collections.map((c) => c.id).join(','),
        collections: '',
        featured_tags,
        is_hidden: upload_is_hidden,
        name,
        optional_tags,
        rating: upload_rating,
        source_url: upload_source_url,
        tags,
        username,
    }
}

export function channelIdFromPreset(preset: CopilotUploadPreset): string {
    const { collections = [] } = preset.upload_collections

    return collections[0]?.id || ''
}

export function isPublicFromPreset(preset: CopilotUploadPreset): boolean {
    return !preset.upload_is_hidden
}

export function ratingFromPreset(preset: CopilotUploadPreset): string {
    return preset.upload_rating.toLowerCase()
}

export function sourceUrlFromPreset(preset: CopilotUploadPreset): string {
    return preset.upload_source_url || ''
}

export function tagsFromPreset(preset: CopilotUploadPreset): CreationToolUploadTag[] {
    const { tags = [] } = preset.upload_tags

    return tags.map((tag) => ({ text: tag.name, isFeatured: tag.is_featured }))
}

export function usernameFromPreset(preset: CopilotUploadPreset): string {
    return preset.upload_channel?.slug || ''
}
